import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  imgData:'',
  listData:''
}
const actions={

}
const mutations ={
  formFun (state,data){
    state.imgData=data
  },
  listFun (state,data){
    state.listData=data
  }
}
const getters = {

}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules:{}
})



// WEBPACK FOOTER //
// ./src/pages/index/store.js